const example = {
  // estimateNeedsFields: {
  //   livingAreaInput: null,
  //   inhabitantsInput: null,
  //   estimateFromRadio: null, // invoices|building_years|consumption
  //   // invoices
  //   invoicesTextArea: null,
  //   //building_years
  //   buildingYearsSelect: null,
  //   // consumption
  //   energyVectorsSelect: null,
  //   consumptionInput: null,
  //   // building_years, consumption
  //   currentHeatingSystemSelect: null,
  //   currentHotWaterSystemSelect: null,
  // },
  needs: {
    heatingNeedsInput: 15000,
    hotWaterNeedsInput: 3000,
  },
  solutions: [
    {
      // HEATING 1
      consideredHeatingSystemSelect: '2',
      heatingGreenEnergyCheckbox: false,
      heatingEstimatedInvestmentInput: null,
      heatingEfficiencyInput: null,
      heatingMaintenanceInput: null,
      heatingEnergyPriceInput: null,
      heatingEnergyPriceVariationInput: null,
      // HOT WATER 1
      consideredHotWaterSystemSelect: '0',
      hotWaterGreenEnergyCheckbox: false,
      hotWaterEstimatedInvestmentInput: null,
      hotWaterEfficiencyInput: null,
      hotWaterMaintenanceInput: null,
      hotWaterEnergyPriceInput: null,
      hotWaterEnergyPriceVariationInput: null,
      // SOLAR 1
      solarSystemSelect: null,
      solarPanelSurfaceInput: null,
      solarEstimatedInvestmentInput: null,
    }, {
      // HEATING 2
      consideredHeatingSystemSelect: '4',
      heatingGreenEnergyCheckbox: false,
      heatingEstimatedInvestmentInput: null,
      heatingEfficiencyInput: null,
      heatingMaintenanceInput: null,
      heatingEnergyPriceInput: null,
      heatingEnergyPriceVariationInput: null,
      // HOT WATER 2
      consideredHotWaterSystemSelect: '0',
      hotWaterGreenEnergyCheckbox: false,
      hotWaterEstimatedInvestmentInput: null,
      hotWaterEfficiencyInput: null,
      hotWaterMaintenanceInput: null,
      hotWaterEnergyPriceInput: null,
      hotWaterEnergyPriceVariationInput: null,
      // SOLAR 2
      solarSystemSelect: '2',
      solarPanelSurfaceInput: 10,
      solarEstimatedInvestmentInput: null,
    }, {
      // HEATING 3
      consideredHeatingSystemSelect: '9',
      heatingGreenEnergyCheckbox: false,
      heatingEstimatedInvestmentInput: null,
      heatingEfficiencyInput: null,
      heatingMaintenanceInput: null,
      heatingEnergyPriceInput: null,
      heatingEnergyPriceVariationInput: null,
      // HOT WATER 3
      consideredHotWaterSystemSelect: '19',
      hotWaterGreenEnergyCheckbox: false,
      hotWaterEstimatedInvestmentInput: null,
      hotWaterEfficiencyInput: null,
      hotWaterMaintenanceInput: null,
      hotWaterEnergyPriceInput: null,
      hotWaterEnergyPriceVariationInput: null,
      // SOLAR 3
      solarSystemSelect: '0',
      solarPanelSurfaceInput: null,
      solarEstimatedInvestmentInput: null,
    }, {
      // HEATING 4
      consideredHeatingSystemSelect: '15',
      heatingGreenEnergyCheckbox: false,
      heatingEstimatedInvestmentInput: null,
      heatingEfficiencyInput: null,
      heatingMaintenanceInput: null,
      heatingEnergyPriceInput: null,
      heatingEnergyPriceVariationInput: null,
      // HOT WATER 4
      consideredHotWaterSystemSelect: '0',
      hotWaterGreenEnergyCheckbox: false,
      hotWaterEstimatedInvestmentInput: null,
      hotWaterEfficiencyInput: null,
      hotWaterMaintenanceInput: null,
      hotWaterEnergyPriceInput: null,
      hotWaterEnergyPriceVariationInput: null,
      // SOLAR 4
      solarSystemSelect: '0',
      solarPanelSurfaceInput: null,
      solarEstimatedInvestmentInput: null,
    },
  ],
};

export default example;



// WEBPACK FOOTER //
// ./assets/javascripts/datas/_example_simulation.js